import { userInputTaskShape } from '@/utils/transformFrontendUserInputTask';

export default function TaskFacilityName({ task }) {
  return task.facilityName;
}

TaskFacilityName.propTypes = {
  task: userInputTaskShape.isRequired,
};
